import React, { Component } from "react";
import styled from "styled-components";
import { BreadCrumbGrid, OrganicLink } from 'components/Global/BreadCrumb';
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";

const ButtonBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-bottom: 10px
  margin-top: 10px;

  div {
    margin-right: auto;
  }

  button { 
    margin-left: 1em;
  }
`;

class HedgeEscrowLedgerHeader extends Component {
  constructor(props) {
    super(props);
  }

  renderBreadCrumb = () => {
    const { breadCrumb } = this.props;
    if (!breadCrumb || !breadCrumb.deal || !breadCrumb.hedge) return null;

    return (
      <BreadCrumbGrid>
        <OrganicLink to="/portfolio/">{'Portfolio / '}</OrganicLink>
        <OrganicLink to={`/portfolio/funds/free/deals/${breadCrumb.deal.id}`}>{`${breadCrumb.deal.display} / `}</OrganicLink>
        <OrganicLink to={`/hedge/free/${breadCrumb.deal.id}/${breadCrumb.hedge.id}`}>{`${breadCrumb.hedge.display} / Hedge Details / `}</OrganicLink>
        <OrganicLink to={`/hedge/free/${breadCrumb.deal.id}/${breadCrumb.hedge.id}/escrowLedger`}>{`Escrow Calculation`}</OrganicLink>
      </BreadCrumbGrid>
    );
  }

  render() {
    const { onRemoveEscrowCalculation, onEditAssumptions } = this.props;
    return (
      <>
        {this.renderBreadCrumb()}

        <ButtonBar>
          <div className="title-component">Escrow Calculation</div>

          <SecondaryButton onClick={onRemoveEscrowCalculation}>
            <span>Remove Escrow Calculation</span>
          </SecondaryButton>

          <PrimaryButton onClick={onEditAssumptions}>
            <span>Edit Assumptions</span>
          </PrimaryButton>
        </ButtonBar>
      </>
    );
  }
}

export default HedgeEscrowLedgerHeader;
